import { MultiDayAppointmentRow } from '../types/agenda.types';
import MultiDayListTable from './MultiDayListTable';

interface WeekListViewProps {
  rows: MultiDayAppointmentRow[];
  loading: boolean;
}

/** Lista de la semana (lente Semana · Lista). */
export default function WeekListView({ rows, loading }: WeekListViewProps) {
  return <MultiDayListTable rows={rows} loading={loading} />;
}
